 import React from "react"
 import style from "./pastor.module.css"
 
 const PastorChurches=()=>{
  return(
 
 <div className="container">
          <div className={style.church}>
            <h1>Why Churches Choose FundLife</h1>
            <p>Energizes the congregation</p>
            <div className={style.churchInner}>
              <div className={style.cardChurch}>
                <img src="/churchImg1.png" alt="Church" />
                <p>No cost to the church</p>
              </div>
              <div className={style.cardChurch}>
                <img src="/churchImg2.png" alt="Church" />
                <p>No offering required</p>
              </div>
              <div className={style.cardChurch}>
                <img src="/churchImg3.png" alt="Church" />
                <p>No administrative burden</p>
              </div>
              <div className={style.cardChurch}>
                <img src="/churchImg4.png" alt="Church" />
                <p>No tech setup</p>
              </div>
              <div className={style.cardChurch}>
                <img src="/churchImg5.png" alt="Church" />
                <p>No staff time needed</p>
              </div>
              <div className={style.cardChurch}>
                <img src="/churchImg6.png" alt="Church" />
                <p>Automated reminders & receipts</p>
              </div>
              <div className={style.cardChurch}>
                <img src="/churchImg7.png" alt="Church" />
                <p>21-day campaign window</p>
              </div>
              <div className={style.cardChurch}>
                <img src="/churchImg8.png" alt="Church" />
                <p>Safe, secure, and transparent</p>
              </div>
            </div>
          </div>
        </div>

  )
 }

  export default PastorChurches;